module.exports = __webpack_public_path__ + "media/icons/delete_all@3x-4ade94b0.svg";